import CsatByHourOfDayBarChart from './CsatByHourOfDayBarChart';
export default CsatByHourOfDayBarChart;



// WEBPACK FOOTER //
// ./src/components/CsatByHourOfDayBarChart/index.js